import React from 'react';
import { useTranslation } from 'react-i18next';
import CAppTitle from '../../../app/components/CAppTitle';
import FDocumentDownloadLogs from '../features/document-download-logs/FDocumentDownloadLogs';
import langAdminDocumentDownloadLogs from '../langs/langAdminDocumentDownloadLogs';

const VAdminDocumentDownloadLogs = () => {
	const { t } = useTranslation();
	return (
		<>
			<CAppTitle title={t(langAdminDocumentDownloadLogs.title.tag)} />

			<FDocumentDownloadLogs />
		</>
	);
};

export default VAdminDocumentDownloadLogs;
